import { RegisterSystemTask } from "event-definitions"
import { handle } from "library/local-events/index.mjs"
import { warningSnackbar } from "lib/snackbar/warning-snackbar"
import { TaskEditor } from "slot-definitions"
import { Frag } from "lib/@components/slot/frag"
import { replaceAllWith } from "lib/@components/slot/replace-all-with"
import { successSnackbar } from "lib/snackbar/success-snackbar"
import { gql } from "@apollo/client"
import { errorSnackbar } from "lib/snackbar/error-snackbar"
import { mutate } from "lib/graphql/mutate"

RegisterSystemTask.handleOnce(({ tasks }) => {
    const task = {
        name: "25-03 Bottled Water Cooler Reset",
        event: "reset-bottled-water-cooler",
        params: {},
    }
    tasks.push(task)
})

handle("reset-bottled-water-cooler", async () => {
    warningSnackbar("Running Reset 25-03 Bottled Water Cooler")
    if (
        await mutate(
            gql`
                mutation Mutation {
                    resetBottledWaterCooler
                }
            `,
            {},
            { returns: "resetBottledWaterCooler" }
        ).catch((e) => {
            console.error(e)
            errorSnackbar(e.message)
        })
    ) {
        successSnackbar("25-03 Bottled Water Cooler Reset")
    } else {
        errorSnackbar("25-03 Bottled Water Cooler Not Reset")
    }
})

TaskEditor("reset-bottled-water-cooler").plug(replaceAllWith(<Frag />))
